<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content cdkFocusInitial>
  @for (pair of pairs; track pair) {
  <div>
    <span>{{ pair[0] }}:</span>
    @if (pair[1].length > 16) {
    <br />
    }
    {{ pair[1] }}
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close tabindex="-1">Close</button>
</mat-dialog-actions>
